// Impresión de recibo de cobro (Cobranzas) en 3 formatos: A4, 80mm y 60mm.
// Mismo patrón que imprimirVenta.js: window.open + document.write + auto-print.

function fmt2(n) {
  return parseFloat(n || 0).toFixed(2);
}

// sale_date es TIMESTAMP real (instante UTC) — se proyecta a Perú
// explícitamente (getDate()/getMonth() usarían la zona del proceso/navegador).
function fmtFechaCorta(d) {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt)) return '—';
  const parts = dt.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: 'America/Lima' });
  return parts;
}

/** Convierte un monto a letras en soles (hasta millones) — igual que imprimirVenta.js */
function numberToWords(amount) {
  const UNIDADES = ['', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
  const DECENAS  = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
  const ESPECIALES = { 11:'ONCE',12:'DOCE',13:'TRECE',14:'CATORCE',15:'QUINCE',
    16:'DIECISÉIS',17:'DIECISIETE',18:'DIECIOCHO',19:'DIECINUEVE' };
  const CENTENAS = ['','CIENTO','DOSCIENTOS','TRESCIENTOS','CUATROCIENTOS',
    'QUINIENTOS','SEISCIENTOS','SETECIENTOS','OCHOCIENTOS','NOVECIENTOS'];

  function cientos(n) {
    if (n === 0) return '';
    if (n === 100) return 'CIEN';
    const c = Math.floor(n / 100), resto = n % 100;
    const centStr = CENTENAS[c];
    if (resto === 0) return centStr;
    if (ESPECIALES[resto]) return (centStr ? centStr + ' ' : '') + ESPECIALES[resto];
    const dec = Math.floor(resto / 10), uni = resto % 10;
    const parts = [];
    if (centStr) parts.push(centStr);
    if (dec > 0) parts.push(DECENAS[dec]);
    if (uni > 0) parts.push(UNIDADES[uni]);
    return parts.join(' Y ');
  }
  function miles(n) {
    if (n === 0) return '';
    const m = Math.floor(n / 1000), resto = n % 1000;
    const milStr = m === 1 ? 'MIL' : (m > 0 ? cientos(m) + ' MIL' : '');
    const restoStr = cientos(resto);
    return [milStr, restoStr].filter(Boolean).join(' ');
  }
  const entero = Math.floor(amount);
  const centavos = Math.round((amount - entero) * 100);
  const palabras = entero === 0 ? 'CERO' : miles(entero);
  return `${palabras} CON ${String(centavos).padStart(2, '0')}/100 SOLES`;
}

const CSS_BY_FMT = {
  a4: `
    @page { size: A4; margin: 15mm; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 12px; max-width: 480px; margin: 0 auto; }
    .rc-doc { font-size: 15px; }
  `,
  '80': `
    @page { size: 80mm auto; margin: 4mm; }
    /* font-weight:700 en el body — en impresoras térmicas de 80mm el texto
       normal (400) sale casi ilegible; negrita se imprime sólida. */
    body { font-family: 'Courier New', Courier, monospace; font-size: 12px; width: 72mm; margin: 0 auto; font-weight: 700; }
  `,
  '60': `
    @page { size: 60mm auto; margin: 3mm; }
    body { font-family: 'Courier New', Courier, monospace; font-size: 9.5px; width: 52mm; margin: 0 auto; }
    .rc-empresa-nombre { font-size: 11px; }
    .rc-lbl { min-width: 55px; }
  `,
};

// `detalle`: arreglo de ventas afectadas por esta cobranza — [{ sale_number,
// document_type, serie, sequence, sale_date, saldo_anterior, monto_cobrado, saldo_actual }].
// Una cobranza puede traer una o varias ventas (cobro múltiple). El número de
// cuota no se muestra en el ticket, solo el documento de la venta — no se
// lleva control con el N° Venta interno (VTA-XXXXXX).
function motivoTexto(d) {
  const doc = d.serie ? `${d.serie}-${d.sequence}` : '';
  return doc || d.sale_number || '—';
}

// `detalle` trae TODAS las ventas con deuda del cliente (no solo las
// afectadas por esta cobranza) — las que no se cobraron en esta operación
// aparecen con Cobrado = 0. `saldo_actual` se mantiene en el objeto por si
// se necesita a futuro, pero no se muestra (para que la fila entre en una
// sola línea en 60mm/80mm).
function buildDetalleTable(detalle) {
  if (!detalle || detalle.length === 0) return '';
  const rows = detalle.map(d => `
    <tr>
      <td>${fmtFechaCorta(d.sale_date)}</td>
      <td>${motivoTexto(d)}</td>
      <td class="rc-r">${fmt2(d.saldo_anterior)}</td>
      <td class="rc-r rc-cobrado-cell">${fmt2(d.monto_cobrado)}</td>
    </tr>`).join('');
  const totalCobrado = detalle.reduce((s, d) => s + parseFloat(d.monto_cobrado || 0), 0);
  return `
    <div class="rc-detalle-title">DETALLE DE LA COBRANZA</div>
    <table class="rc-detalle-table">
      <thead>
        <tr>
          <th>Fecha</th><th>Venta</th><th class="rc-r">Deuda (S/)</th><th class="rc-r">Cobrado (S/)</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
      ${detalle.length > 1 ? `
      <tfoot>
        <tr>
          <td colspan="3" class="rc-r rc-total-lbl">TOTAL COBRADO</td>
          <td class="rc-r rc-cobrado-cell">${fmt2(totalCobrado)}</td>
        </tr>
      </tfoot>` : ''}
    </table>`;
}

function buildHtml({ empresa, payment_id, paid_at, client_name, client_document, payment_method, username, detalle, client_total_debt, notes }, fmt) {
  const fechaTxt = paid_at ? new Date(paid_at).toLocaleString('es-PE', { timeZone: 'America/Lima' }) : new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
  const det = detalle && detalle.length > 0 ? detalle : [];
  const totalCobrado = det.reduce((s, d) => s + parseFloat(d.monto_cobrado || 0), 0);

  return `<!DOCTYPE html><html><head><meta charset="UTF-8">
    <style>
      hr { border: none; border-top: 1px dashed #666; margin: 6px 0; }
      .rc-empresa-nombre { text-align:center; font-weight:700; text-transform:uppercase; }
      .rc-empresa-linea { text-align:center; font-size:0.85em; color:#333; }
      .rc-doc { text-align:center; font-weight:700; margin:6px 0; text-transform:uppercase; }
      .rc-info-row { display:flex; gap:4px; margin-bottom:2px; }
      .rc-lbl { font-weight:600; min-width:90px; flex-shrink:0; }
      .rc-detalle-title { font-weight:700; font-size:0.85em; margin:10px 0 4px; text-transform:uppercase; color:#333; }
      .rc-detalle-table { width:100%; border-collapse:collapse; font-size:0.9em; }
      .rc-detalle-table th, .rc-detalle-table td { padding:3px 4px; border-bottom:1px dashed #ccc; text-align:left; }
      .rc-r { text-align:right; }
      .rc-cobrado-cell { font-weight:800; }
      .rc-total-lbl { font-weight:700; }
      .rc-monto-box { text-align:center; margin:10px 0; padding:8px 0; border-top:1px dashed #666; border-bottom:1px dashed #666; }
      .rc-monto-box .rc-monto { font-size:1.6em; font-weight:800; }
      ${CSS_BY_FMT[fmt] || CSS_BY_FMT['80']}
    </style>
    </head><body>
      <div class="rc-empresa-nombre">${empresa?.name || ''}</div>
      ${empresa?.address ? `<div class="rc-empresa-linea">${empresa.address}</div>` : ''}
      <hr />
      <div class="rc-doc">RECIBO DE COBRO N° ${payment_id}</div>
      <hr />
      <div>
        <div class="rc-info-row"><span class="rc-lbl">CLIENTE:</span><span>${client_name || 'CLIENTES VARIOS'}</span></div>
        ${client_document ? `<div class="rc-info-row"><span class="rc-lbl">DNI/RUC:</span><span>${client_document}</span></div>` : ''}
        <div class="rc-info-row"><span class="rc-lbl">FECHA:</span><span>${fechaTxt}</span></div>
        <div class="rc-info-row"><span class="rc-lbl">FORMA PAGO:</span><span>${payment_method || '-'}</span></div>
        <div class="rc-info-row"><span class="rc-lbl">REGISTRADO POR:</span><span>${username || '-'}</span></div>
      </div>
      ${buildDetalleTable(det)}
      <div class="rc-monto-box">
        <div>MONTO COBRADO${det.length > 1 ? ' (TOTAL)' : ''}</div>
        <div class="rc-monto">S/ ${fmt2(totalCobrado)}</div>
      </div>
      <div style="font-size:0.9em">
        <div class="rc-info-row"><span class="rc-lbl">SON:</span><span style="flex:1">${numberToWords(totalCobrado)}</span></div>
      </div>
      ${client_total_debt != null ? `
      <hr />
      <div class="rc-info-row"><span class="rc-lbl">DEUDA TOTAL:</span><span style="font-weight:700">S/ ${fmt2(client_total_debt)}</span></div>
      <hr />` : ''}
      ${notes ? `<hr /><div class="rc-info-row"><span class="rc-lbl">NOTAS:</span><span style="flex:1">${notes}</span></div>` : ''}
      <script>window.onload = () => { window.print(); };</script>
    </body></html>`;
}

const WINDOW_SIZE = { a4: 'width=650,height=800', '80': 'width=420,height=650', '60': 'width=360,height=650' };

/**
 * Abre una ventana nueva e imprime un recibo de cobro (Cobranzas) en el formato indicado.
 * @param {object} data { empresa, payment_id, paid_at, client_name, client_document, payment_method,
 *   username, notes, client_total_debt, detalle: [{ sale_number, document_type, serie, sequence,
 *   sale_date, saldo_anterior, monto_cobrado, saldo_actual }] } — `detalle` trae una entrada por cada
 *   venta afectada (una o varias, en un cobro múltiple). `client_total_debt` es la deuda total
 *   del cliente sumando TODAS sus cuentas por cobrar (no solo las de este recibo) y se muestra
 *   al final como "DEUDA TOTAL". `notes`, si trae texto, se muestra al final de todo como "NOTAS:".
 * @param {'a4'|'80'|'60'} fmt
 */
export function imprimirRecibo(data, fmt = '80') {
  const html = buildHtml(data, fmt);
  const win = window.open('', '_blank', WINDOW_SIZE[fmt] || WINDOW_SIZE['80']);
  if (!win) return;
  win.document.write(html);
  win.document.close();
}
